import { Property, SelectInput } from '@/components/form/fields/select/SelectInput';
import { FinanceModel, PeripheralFinanceModel } from '@/services/api/contracts/financemodels';
import { FC } from 'react';
import { CAPITAL_PURCHASE_OPTION } from '../../financeModels/const';

interface Props {
  models: (FinanceModel | PeripheralFinanceModel)[];
  selectedModelName?: string;
  onChange: (id: string) => void;
}

export const PurchaseOrderFinanceModelCard: FC<Props> = ({ models, selectedModelName, onChange }) => {
  const onModelChange = (value: Property | null) => {
    if (value && value.id) {
      onChange(value.id);
    }
  };

  const selectedModelOptions: Property[] = [
    CAPITAL_PURCHASE_OPTION,
    ...models.map(m => {
      return {
        name: m.name,
        id: m.id
      };
    })
  ];

  const selectedModel = models.find(model => model.name === selectedModelName);

  return (
    <div className="flex items-center py-1 space-x-5">
      <span className="text-2xl font-bold">Finance Model</span>

      <SelectInput
        className="w-[300px]"
        id={''}
        placeholder="Please Select"
        options={selectedModelOptions}
        value={selectedModelOptions.find(o => o.id === selectedModel?.id) || CAPITAL_PURCHASE_OPTION}
        onChange={onModelChange}
      />
    </div>
  );
};
